import { useSiteCredit } from "@/hooks/useSiteCredit";
import emfLogo from "@/assets/emfjewellers-logo.webp";

/**
 * Site-wide credit footer. Rendered once in App so it appears on every route.
 * Reads the customizable site credit so users can rebrand the attribution.
 */
export function SiteFooter() {
  const { credit } = useSiteCredit();
  const year = new Date().getFullYear();
  return (
    <footer className="mt-12 border-t border-border bg-background/60 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-muted-foreground">
        <span>© {year} MGL — Metal Gem Ledger</span>
        <a
          href={credit.url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 group"
        >
          <img
            src={emfLogo}
            alt={`${credit.name} logo`}
            width={1024}
            height={1024}
            loading="lazy"
            decoding="async"
            className="img-crisp h-5 w-5 rounded bg-black object-cover ring-1 ring-primary/30"
          />
          <span className="text-primary group-hover:underline font-medium">
            {credit.name}
          </span>
        </a>
      </div>
    </footer>
  );
}

export default SiteFooter;
